export const setTacArr = (state,Tac)=>{
    state.tac = Tac
};